// import Constants from 'expo-constants';
// import * as Notifications from 'expo-notifications';
// import * as Permissions from 'expo-permissions';
// import React from 'react';
// import {
//   Text,
//   View,
//   Button,
//   Platform,
// } from 'react-native';

// Notifications.setNotificationHandler({
//   handleNotification: async () => ({
//     shouldShowAlert: true,
//     shouldPlaySound: false,
//     shouldSetBadge: false,
//   }),
// });

const NotificationHandler = () => null;

export default NotificationHandler;
